import React from "react";
import { Navigate, RouteProps, useLocation } from "react-router-dom";
import { useUserLoggedInStatus } from "../../../shared/state/user";

const isSafeRelativePath = (path: string) =>
  path.startsWith("/") && !path.startsWith("//");

type LoginLayoutRouteProps = Pick<RouteProps, "element">;
export const LoginLayoutRoute: React.FC<LoginLayoutRouteProps> = ({
  element,
}) => {
  const isLoggedIn = useUserLoggedInStatus();
  const { search } = useLocation();

  if (isLoggedIn) {
    const next = new URLSearchParams(search).get("next");
    const to = next && isSafeRelativePath(next) ? next : "/";
    return <Navigate to={to} />;
  }

  return element;
};
